module.exports = __webpack_public_path__ + "static/media/38.cd322f7f.jpg";